import { useQuery, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';
import { useEvent } from '../../../hooks/useEvent';

const emptyArr = [];

const getFlatsGrid = async (houseId) => {
  return await request.get(
    '/FlatsGrid',
    { houseId },
    'При загрузке квартир произошла ошибка',
    emptyArr
  );
};

const useFlatsGrid = (houseId, options) =>
  useQuery(getQueryKeys.flatsGrid(houseId), () => getFlatsGrid(houseId), {
    placeholderData: emptyArr,
    enabled: Boolean(houseId),
    ...options,
  });

const useSyncUpdateFlatsGrid = () => {
  const queryClient = useQueryClient();
  return useEvent((...args) => queryClient.setQueryData(...args));
};

const useInvalidateFlatsGrid = (key) => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(key);
};

export { useSyncUpdateFlatsGrid, useInvalidateFlatsGrid };

export default useFlatsGrid;
